import { PrintNodeInfoRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class PrintNodeInfoService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new PrintNodeInfoRouteService());
	}

	getPrinters(apiKey) {
		var url = this.routeService.getPrinters(apiKey);
		return this.apiClient.get(url);
	}

	findPrintNodeInfo(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default PrintNodeInfoService;



// WEBPACK FOOTER //
// ./src/common/data/services/PrintNodeInfoService.js